import DetailsTab from '@/components/details-tab/details-tab';
import { getEntityQueryOptions } from '@/queries/getEntityQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab/',
)({
  component: RouteComponent,
  loader: async ({ context: { queryClient }, params }) => {

    const { entity_type_id, entity_id } = params;
    await queryClient.ensureQueryData(getEntityQueryOptions(entity_type_id, entity_id));
  }
})

function RouteComponent() {
  const { entity_type_id, entity_id, detailsTab } = Route.useParams();
  const { data: result } = useQuery(getEntityQueryOptions(entity_type_id, entity_id));
  if (!result) {
    return <div>Error</div>
  }

  const tabName = detailsTab?.toLowerCase().replace(/ /g, "-") ?? "details";

  const currentTab = result?.view?.tabs?.find(tab => tab.name?.toLowerCase().replace(/ /g, "-") === tabName);
  if (!currentTab) {
    return <div>Error</div>
  }

  return <>
    <div className="m-4">
      <DetailsTab
        entity={result?.entity}
        tab={currentTab}
        entity_type_id={entity_type_id}
        isEditing={true}
      />
      <div style={{ height: "200px" }}></div> {/* Added padding instead of fixed height for better scrolling */}
    </div>
  </>
}
